import {ActionTypes} from '../types/actionTypes';
import {Action} from '../typescript/actionTypes';
import {StoreSettings} from '../typescript/storeTypes';
import {InitialState} from './initialState';

export default function (state: StoreSettings = InitialState.settings, action: Action): StoreSettings {
    switch (action.type) {
        case ActionTypes.UPDATE_SETTING: {
            return Object.assign({}, state, action.payload);
        }
        default: {
            return state;
        }
    }
}
